import React from "react";
import { ReactErrorProvider } from "shared/appContainers/components";

export const ErrorBoundaryLayout = ({ children }: AppRootType) => (
  <ReactErrorProvider>{children}</ReactErrorProvider>
);

type AppRootType = { children: React.ReactNode };
